module.exports = __webpack_public_path__ + "img/word.de90000f.svg";